import React from 'react'
import PropTypes from 'prop-types'
import styled from 'react-emotion'
import Benefit from './Benefit'

const Benefits = ({ benefits }) => (
  <div>
    {benefits.edges.map((benefit, index) =>
      <Benefit key={index} className={'direction-' + (index % 2 ? 'r':'l')} {...benefit.node} />
    )}
  </div>
)

Benefits.propTypes = {
  benefits: PropTypes.object.isRequired
}

export default Benefits



// WEBPACK FOOTER //
// ./src/components/Benefits/index.js